import * as React from "react"

import type { GatsbyBrowser } from "gatsby"
import RootElement from "./gatsby-shared"

/**
 * The New CSS Reset made by Elad Shechter
 * @url https://github.com/elad2412/the-new-css-reset
 */
import "./src/styles/the-new-css-reset.css"
import "./src/styles/global-css-variables.css"
import "@fontsource/open-sans/400.css"
import "@fontsource/open-sans/700.css"

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({
  element,
}) => {
  return <RootElement>{element}</RootElement>
}
